<template>
    <div class="page-content" id="phonebook-form">
        <Titlebar :incrustation="'fa-address-book'" :backPath="'/parameters/phonebooks'">
            <h1 v-if="!editMode"><span>{{ $t('phonebook.titles.new') }}</span> <span v-if="namePhonebook">"</span><span style="font-weight: 900">{{ namePhonebook
                }}</span><span v-if="namePhonebook">"</span></h1>
            <h1 v-if="editMode">{{ namePhonebook }}</h1>
        </Titlebar>
        <div class="row">
            <div class="col-12 col-xl-4 mb-4">
                <UiCard>
                    <form >
                        <h2 class="mt-0"><i class="fa fa-address-book"></i>{{ $t('phonebook.phonebook') }}</h2>
                        <div class="form-row row mb-0">
                            <label class="col-4">{{ $t('phonebook.cols.namePhonebook') }}</label>
                            <input type="text" class="form-input col" v-model="namePhonebook"/>
                        </div>
                    </form>
                </UiCard>
            </div>
            <div class="col-12 col-xl-8 full-height mb-4">
                <UiCard>
                    <form>
                        <h2 class="mt-0"><i class="fa fa-users"></i>{{ $t('phonebook.contacts') }}</h2>
                        <div class="mb-4">
                            <SuperTable :tableColumns="tableColumns" :tableData="tableData" :options="sortableOptions" @endDrag="onEndDrag" @rowEdit="onEditAction" @rowDelete="onDeleteAction" />
                        </div>
                        <div class="d-flex gap-2" v-can="'beepiz-edit-phonebooks'">
                            <input type="text" class="form-input flex-1" v-model="nameContact" maxlength="64" :placeholder="$t('phonebook.cols.contactName')">
                            <input type="text" class="form-input flex-1" name="phoneContact" v-model="phoneContact" maxlength="14" v-inputmask="{regex: '[\\+0]?[0-9]{2,14}'}" :placeholder="$t('phonebook.cols.phoneNumber')">
                            <div class="form-input-error" v-show="!showErrors['phoneContact'] && errors.has('phoneContact')"
                                    @click="hideError('phoneContact')">{{ errors.first('phoneContact') }}</div>
                            <Btn class="icon" @click.native.prevent="clearContactForm"><i class="fa fa-times"></i></Btn>
                            <Btn @click.native.prevent="addOrEditContact">{{ contactFormBtnLabel }}</Btn>
                        </div>
                    </form>
                </UiCard>
            </div>
        </div>
        <Toolbar class="justify-content-end pt-0">
            <Btn>
                <router-link to="/parameters/phonebooks" tag="span">{{ $t('global.cancel') }}</router-link>
            </Btn>
            <Btn class="primary" @click.native.stop="validForm()" :class="(!!this.namePhonebook)?'':'disabled'" v-can="'beepiz-edit-phonebooks'">{{ $t('global.save') }}</Btn>
        </Toolbar>
    </div>
</template>

<script>

    import axios from 'axios';
    import API from '@/services/API.js';
    import Utils from '@/services/utils.js';
    import Titlebar from "@/components/ui/Titlebar";
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import UiCard from "@/components/ui/Card";
    import SuperTable from "@/components/ui/Table";
    import {useDvFlagAccess} from "../../services/featureFlag";

    export default {
        name: 'PhonebooksForm',
        components: {
            Titlebar,
            Toolbar,
            Btn,
            UiCard,
            SuperTable,
        },
        data: () => ({
                namePhonebook: "",
                nameContact: "",
                phoneContact: "",
                formEdit: false,
                editMode: false,
                bookId: null,
                sortableOptions: {
                    disabled: true
                },
                contactFormBtnLabel: window.V.$i18n.t('global.add'),
                tableColumns: {
                    global: {
                        sortable: true,
                        noItemsMsg: window.V.$i18n.t('phonebook.emptyContactTable')
                    },
                    columns: [
                        {
                            key: 'name',
                            label: Utils.t('phonebook.cols.contactName'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: false,
                            filter: false,
                            width: '40%'
                        },
                        {
                            key: 'phone',
                            label: Utils.t('phonebook.cols.phoneNumber'),
                            showPopup: false,
                            activeFilter: '',
                            activeSort: false,
                            sortable: false,
                            filter: false,
                            width: '40%'
                        }

                    ],
                    rowActions: {
                        width: '20%',
                        actions: [
                            {
                                label: Utils.t('global.edit'),
                                event: 'rowEdit',
                                class: 'fa fa-pencil'
                            },
                            {
                                label: Utils.t('global.delete'),
                                event: 'rowDelete',
                                class: 'fa fa-trash'
                            }
                        ]
                    }
                },
                tableData: [],
                showErrors: {
                    phoneContact: false
                }
            }

        ),
        methods: {
            onEditAction: function(item){
                this.nameContact = item.name;
                this.phoneContact = item.phone;
                this.formEdit = item;
                this.contactFormBtnLabel = window.V.$i18n.t('global.edit');
            },
            onDeleteAction: function(item){
                var key = this.searchItem(item);
                if(this.editMode){
                    window.Vfc.$refs.confirm.show({
                        title: Utils.t('global.deleteModalTitle'),
                        content: Utils.t('global.deleteModalContent'),
                        callbackYes: () => {
                            axios.delete(API.route(API.endpoints.phonebooks.contacts.delete,{bookId:this.bookId,contactId:item.id}))
                                .then(response => {
                                })
                            this.tableData.splice(key,1);
                        }
                    });
                }
                else{
                    this.tableData.splice(key,1);
                }
            },
            clearContactForm: function(){
                this.nameContact = "";
                this.phoneContact = "";
                this.formEdit = false;
                this.contactFormBtnLabel = window.V.$i18n.t('global.add');
            },
            onEndDrag: function(){
                var objToEdit = [];
                for(var cKey in this.tableData){
                    objToEdit.push(this.tableData[cKey].id);
                }
                axios.put(API.route(API.endpoints.phonebooks.contacts.order,{bookId:this.bookId}),objToEdit)
                    .then(response => {
                    })
            },
            addOrEditContact: function(){
                if(this.nameContact != "" && this.phoneContact != "")
                {

                    this.phoneContact = this.phoneContact.replace('_','');
                    if(this.phoneContact.length < 2){
                        window.Vfc.$refs.messages.sendMessage('error', Utils.t('phonebook.errors.phoneformat'));
                        return;
                    }

                    if(this.formEdit !== false){
                        var item = this.formEdit;
                        var key = this.searchItem(item);
                        item.name = this.nameContact;
                        item.phone = this.phoneContact;
                        this.tableData[key] = item;
                        var objToEdit = {
                            name: item.name,
                            phone: item.phone
                        };
                        axios.put(API.route(API.endpoints.phonebooks.contacts.edit,{bookId:this.bookId,contactId:item.id}),[objToEdit])
                            .then(response => {
                                window.Vfc.$refs.messages.sendMessage('success', Utils.t('phonebook.success'));
                                this.clearContactForm();
                            })
                            .catch(error => {
                                if (error.response != null) {
                                    var errorBag = this.$validator.errorBag;
                                    if (error.response.status == 422) {
                                        for(var eKey in error.response.data.message){
                                            window.Vfc.$refs.messages.sendMessage('error', error.response.data.message[eKey]);
                                        }
                                    }

                                }
                                else {
                                }
                                window.Vfc.$refs.loading.hide();
                            })
                    }
                    else
                    {
                        var objToAdd = {name:this.nameContact, phone:this.phoneContact}
                        if(this.editMode){
                            axios.post(API.route(API.endpoints.phonebooks.contacts.add,{bookId:this.bookId}),[objToAdd])
                                .then(response => {
                                    objToAdd.id = response.data.message;
                                    this.tableData.push(objToAdd);
                                    this.tableData.sort(function(a,b) {return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0);} );
                                    window.Vfc.$refs.messages.sendMessage('success', Utils.t('phonebook.success'));
                                    this.clearContactForm();
                                })
                                .catch(error => {
                                    if (error.response != null) {
                                        var errorBag = this.$validator.errorBag;
                                        if (error.response.status == 422) {
                                            for(var eKey in error.response.data.message){
                                                window.Vfc.$refs.messages.sendMessage('error', error.response.data.message[eKey]);
                                            }

                                        }

                                    }
                                    else {
                                    }
                                    window.Vfc.$refs.loading.hide();
                                })

                        }
                        else{
                            this.tableData.push(objToAdd);
                            this.tableData.sort(function(a,b) {return (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0);} );
                        }
                    }

                }

            },
            searchItem: function(item){
                if(this.tableData[0].id != null){
                    for(var key in this.tableData){
                        if(this.tableData[key].id == item.id){
                            return key;
                        }
                    }
                }
                else{
                    for(var key in this.tableData){
                        if(this.tableData[key].name == item.name && this.tableData[key].phone == item.phone){
                            return key;
                        }
                    }
                }
                return false;
            },
            validForm: function () {
                window.Vfc.$refs.loading.show();
                var objToEdit = {
                    name: this.namePhonebook
                };
                if(this.editMode){
                    axios.put(API.route(API.endpoints.phonebooks.edit,{bookId:this.bookId}),objToEdit)
                        .then(response => {
                            window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                            window.Vfc.$refs.loading.hide();
                        })
                        .catch(error => {
                            if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    for(var eKey in error.response.data.message){
                                        window.Vfc.$refs.messages.sendMessage('error', error.response.data.message[eKey]);
                                    }

                                }

                            }
                            else {
                            }
                            window.Vfc.$refs.loading.hide();
                        })
                }
                else{
                    axios.post(API.endpoints.phonebooks.add,objToEdit)
                        .then(response => {
                            var bookId = response.data.message;
                            axios.post(API.route(API.endpoints.phonebooks.contacts.add,{bookId: bookId}),this.tableData)
                                .then(response2 => {
                                    window.Vfc.$refs.messages.sendMessage('success', Utils.t('global.dataSaved'));
                                    window.V._router.replace('/parameters/phonebooks/' + response.data.message, () => {
                                        this.loadData();
                                    });
                                })
                        })
                        .catch(error => {
                            if (error.response != null) {
                                var errorBag = this.$validator.errorBag;
                                if (error.response.status == 422) {
                                    for(var eKey in error.response.data.message){
                                        window.Vfc.$refs.messages.sendMessage('error', error.response.data.message[eKey]);
                                    }

                                }

                            }
                            else {
                            }
                            window.Vfc.$refs.loading.hide();
                        })
                }
            },
            loadData: function (contactsOnly) {
                this.bookId = this.$route.params.id;
                if(this.bookId) {
                    this.editMode = true;
                }
                window.Vfc.$refs.loading.show();
                axios.get(API.route(API.endpoints.phonebooks.show, {bookId: this.bookId}))
                    .then(response => {
                        this.namePhonebook = response.data.name;
                        var contactList = response.data.contacts ?? [];
                        if (this.$route.meta.specialAction == 'copy') {
                            this.editMode = false;
                            this.bookId = null;
                            for(var cKey in contactList){
                                var contact = contactList[cKey];
                                delete contact.icon;
                                delete contact.id;
                                delete contact.version;
                            }
                        }
                        this.tableData = contactList;
                        window.Vfc.$refs.loading.hide();
                    })
            },
        },
        created(){

        },
        mounted(){
            this.bookId = this.$route.params.id;
            if (!useDvFlagAccess("beepiz-phonebook-can:read")) {
              this.$router.push({ name: 'AccessDenied', params: { slug: 'phonebooks'} })
            }
            if(!useDvFlagAccess("beepiz-phonebook-can:create")){
                this.tableColumns.rowActions.actions = [];
            }
            if(this.bookId){
                this.editMode = true;
                this.loadData();
            }
            else{
                window.Vfc.$refs.loading.hide();
            }

        }
    }
</script>

<style lang="scss" scoped>

</style>
